// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"EN-z","categoryName":"FN-z","categoryNameSearchHeader":"GN-z","categoryContent":"HN-z","bottomAligned":"IN-z","image":"JN-z","imageNoBackground":"KN-z"};